import { Component, OnInit, ViewChild } from '@angular/core';
import { fadeInOut } from '../../../shared/helpers/animations';
import { AuthenticationService, AuthorizationService, SettingsService } from './../../../shared/services';
import { SelectedEventArgs } from '@syncfusion/ej2-angular-inputs';
import { EmitType } from '@syncfusion/ej2-base';
import { IApiResult } from '../../../shared/models/api-result';
import { FeatureService } from '../../../shared/services/feature.service';
import { FileUploadHistoryGridComponent } from '../../grids/fileuploadhistorygrid/fileuploadhistorygrid.component';

@Component({
    selector: 'app-spl-upload',
    templateUrl: './spl-upload.component.html',
    styleUrls: ['./spl-upload.component.scss'],
    animations: [fadeInOut],
})
export class SplUploadComponent implements OnInit {
    @ViewChild('fileuploadhistorygrid', { static: false }) fileuploadhistorygrid: FileUploadHistoryGridComponent;

    loading = false;
    uploadSaveUrl: string;
    uploadStatus: string;
    isFeatureFlagVisible: boolean = false;
    hasIngestPermission: boolean = false;
    
    constructor(private settingsService: SettingsService, private authService: AuthenticationService, private authorizationService: AuthorizationService, private featureService: FeatureService) {
    }

    ngOnInit(): void {
        this.hasIngestPermission = this.authorizationService.hasPermission('SSDP.CanIngestLLForm');
        this.uploadSaveUrl = this.getProcessFormURL();
        this.initTabIndex();
        this.setFeatureFlag('ssdp-spl-upload');
    }

    initTabIndex() {
        (document.activeElement as HTMLElement).blur();
        const main = document.getElementById("firstDiv");
        if (main) {
          main.focus();
        }
    }

    onFileUploadStart: EmitType<SelectedEventArgs> = (args: any) => {
        // this.resetPage();
        if (args) {
          const authData = this.authService.getAuthData();
    
          args.currentRequest.setRequestHeader('authorization', this.authService.getBearerToken());
          args.currentRequest.setRequestHeader('customerGuid', this.settingsService.getCustomerGuid());
          args.currentRequest.setRequestHeader('applicationVariantId', authData.applicationVariantId ? authData.applicationVariantId.toString() : '');
          args.currentRequest.setRequestHeader('modifiedByUser', this.settingsService.getUserDataName());
    
          if (!args.cancel) {
            this.loading = true;
          }
        }
    }

    onFileUploadedSuccess: EmitType<Object> = (args: any) => {
        this.loading = false;
        this.uploadStatus = 'Uploaded Successfully';
        this.fileuploadhistorygrid.getFileHistoryDashboard();
        this.fileuploadhistorygrid.needsToPoll = true;
    }

    onUploadFailure(event){
        this.loading = false;
    }

    getProcessFormURL(): string {
        const settings = this.settingsService.getSettings();
        const apiUrl = settings.ApiGatewayUrl;
        const action = `ssdpds/v1/SplUpload/Upload`;
        return `${apiUrl}/${action}`;
    }


    setFeatureFlag(name: string) {
      this.featureService.IsFeatureEnabled(name)
      .subscribe(data => {
        if (data) {
          this.isFeatureFlagVisible = data
        }
        else {
          this.isFeatureFlagVisible = false;
        }
      }, error => {
        // An error has occured. For safe measure, hide the feature.
        this.isFeatureFlagVisible = false;

        // Log to the console since we do not want to alert the user to a feature they may not have
        console.log(`An error has occured checking if the following feature is enabled: ${name}`)
      });
    }

}


